import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  constructor() { }

  sortMenuItems(items: MenuItem[]): MenuItem[] {
    return items.sort((a, b) => {
      // Handle undefined labels by placing them at the end
      const labelA = a.label || 'zzz'; // Use a high string value for undefined
      const labelB = b.label || 'zzz';
      // Sort alphabetically, but keep "Inicio" first even if undefined
      if (labelA.toLowerCase() === 'Dashboard'.toLowerCase() || labelB.toLowerCase() === 'Salir'.toLowerCase()) {
        return -1;
      } else if (labelB.toLowerCase() === 'Dashboard'.toLowerCase() || labelA.toLowerCase() === 'Salir'.toLowerCase()) {
        return 1;
      } else {
        return labelA.localeCompare(labelB, undefined, { sensitivity: 'base' }); // Base sensitivity for case-insensitive sorting
      }
    });
  }
}
